import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export const AUTOMATIONS_ICON = $icon('clock-bolt');
export const AUTOMATIONS_SKILL_NAME = 'automations';
//# sourceMappingURL=constants.js.map